import * as THREE from "three";

export interface Biome {
  name: string;
  nebula: {
    colorA: THREE.Color;
    colorB: THREE.Color;
    colorC: THREE.Color;
  };
  ring: THREE.Color;        // base ring tint
  fog: THREE.Color;          // exp2 fog color
}

// Each biome occupies a band of ring-indices. Player transitions at the edge.
export const BIOMES: Biome[] = [
  {
    name: "Helios",
    nebula: {
      colorA: new THREE.Color("#03040a"),
      colorB: new THREE.Color("#0a0e22"),
      colorC: new THREE.Color("#5a1e7a"),
    },
    ring: new THREE.Color("#00e0ff"),
    fog: new THREE.Color("#05060a"),
  },
  {
    name: "Vermilion",
    nebula: {
      colorA: new THREE.Color("#0a0207"),
      colorB: new THREE.Color("#220a14"),
      colorC: new THREE.Color("#ff5b3a"),
    },
    ring: new THREE.Color("#ffb347"),
    fog: new THREE.Color("#0e0408"),
  },
  {
    name: "Cyan Reach",
    nebula: {
      colorA: new THREE.Color("#02080a"),
      colorB: new THREE.Color("#04222a"),
      colorC: new THREE.Color("#1ae0c8"),
    },
    ring: new THREE.Color("#aaffea"),
    fog: new THREE.Color("#03080a"),
  },
  {
    name: "Magnetar",
    nebula: {
      colorA: new THREE.Color("#04030a"),
      colorB: new THREE.Color("#10042a"),
      colorC: new THREE.Color("#a83dff"),
    },
    ring: new THREE.Color("#e6a8ff"),
    fog: new THREE.Color("#05030a"),
  },
];

const RINGS_PER_BIOME = 15;
const TRANSITION_RINGS = 4; // how many rings the crossfade spans

/**
 * For a given progressed ring index, return the (from, to, t) tuple so the
 * caller can lerp colors. t=0 means fully on `from`; t=1 means fully on `to`.
 */
export function biomeFor(ringIdx: number): { from: Biome; to: Biome; t: number; index: number } {
  const cycle = ringIdx / RINGS_PER_BIOME;
  const baseIdx = Math.floor(cycle) % BIOMES.length;
  const nextIdx = (baseIdx + 1) % BIOMES.length;
  const within = (ringIdx % RINGS_PER_BIOME);
  const transitionStart = RINGS_PER_BIOME - TRANSITION_RINGS;
  let t = 0;
  if (within >= transitionStart) {
    t = (within - transitionStart) / TRANSITION_RINGS;
  }
  return {
    from: BIOMES[baseIdx],
    to: BIOMES[nextIdx],
    t: THREE.MathUtils.clamp(t, 0, 1),
    index: baseIdx,
  };
}
